import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/youhuiquan.png'


const _withScopeId = n => (_pushScopeId("data-v-2dd2a87a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-img" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { class: "price" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Youhuiquan = _resolveComponent("Youhuiquan")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "bottom",
    width: 456,
    trigger: "hover"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Youhuiquan, { couponList: _ctx.couponList }, null, 8, ["couponList"])
    ]),
    reference: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.couponList.data[_ctx.couponsIndex].amount), 1)
        ])
      ])
    ]),
    _: 1
  }))
}